<template>
  <div
    id="data-access-settings"
    class="body-padding-full"
    style="max-width: 720px;"
  >
    <!-- Banner explaining the feature -->
    <div class="bg-brand-50 rounded-lg p-4 mb-6">
      <p class="text-emphasis text-sm font-semibold mb-1">
        Data Access Permissions
      </p>
      <p class="text-default text-sm font-normal mb-4">
        Control which records users can view, edit and delete based on their user role.
        Data access is configured in Next-Gen but applies to all Live App users, including in Classic.
      </p>
      <div class="flex items-center">
        <a
          :href="builderNextDataAccessUrl"
          class="text-gradient-primary inline-flex items-center text-sm font-medium underline"
        >
          Configure in Next-Gen
        </a>
        <a
          href="https://docs.knack.com/docs/data-access"
          class="text-subtle hover:text-default underline ml-6 flex items-center text-sm font-medium"
          target="_blank"
          rel="noopener noreferrer"
        >
          <span>Learn More</span>
          <Icon
            type="arrow-top-right-on-square"
            class="h-4 w-4 ml-1"
          />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from '@/components/ui/Icon';
import FieldUtils from '@/components/fields/FieldUtils';
import { getBuilderNextBaseUrl } from '@/lib/url-helper';

export default {
  name: 'ObjectSettingsDataAccess',
  components: {
    Icon,
  },
  mixins: [
    FieldUtils,
  ],
  computed: {
    builderNextDataAccessUrl() {
      const baseUrl = getBuilderNextBaseUrl();

      return `${baseUrl}/roles/${this.object.key}/data-access?origin=v3`;
    },
  },
};
</script>
